import { BetaFeature } from "@tvg/sh-lib-beta-program/types";
import { BaseEventProps } from "../../types";

export type EventProps = BaseEventProps;

export enum MediatorEventType {
  ONBOARDING_VIEW = "BETA-PROGRAM:VIEW_ONBOARDING_MODAL",
  ONBOARD_CTA = "BETA-PROGRAM:CLICK_CTA_SPLASH_MODAL",
  EXIT_VIEW = "BETA-PROGRAM:VIEW_EXIT_MODAL",
  EXIT_CTA = "BETA-PROGRAM:CLICK_CTA_EXIT_MODAL",
  LEARN_MORE_VIEW = "BETA-PROGRAM:VIEW_LEARN_MORE_MODAL",
  LEARN_MORE_CTA = "BETA-PROGRAM:CLICK_CTA_LEARN_MORE_MODAL",
  FEEDBACK_OPEN = "BETA-PROGRAM:OPEN_FEEDBACK_WIDGET",
  FEEDBACK_SUBMIT = "BETA-PROGRAM:SUBMIT_FEEDBACK_WIDGET",
  ACCOUNT_PANEL_LINK = "BETA_PROGRAM:CLICK_ACCOUNT_PANEL_ONBOARDING_LINK",
  WELCOME_VIEW = "BETA_PROGRAM:VIEW_WELCOME_MODAL",
  LETS_START_CTA = "BETA_PROGRAM:CLICK_CTA_LETS_START"
}

// Payload type data
export interface Payload<T> {
  payload: T;
}

export interface ViewOnboardModal {
  betaFeature: BetaFeature;
}

export interface ModalCTA {
  eventLabel: string;
}

export interface AccountPanelNavigation extends ModalCTA {
  destinationUrl: string;
}

export interface ViewWelcomeModal {
  betaFeature: BetaFeature;
}
